import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box , Typography, Stack} from '@mui/material';
// components
import { useChart } from '../../../components/chart';

// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppWebsiteVisits({ title, subheader, chartLabels, chartData, toolLabel, ...other }) {
  const LabelChecker = toolLabel !== undefined ? toolLabel : chartLabels;
  const chartOptions = useChart({
    plotOptions: { bar: { columnWidth: '16%' } },
    fill: { type: chartData.map((i) => i.fill) },
    labels: LabelChecker,
    colors: ['#FFC60B'],
    xaxis: { type: 'text' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} counts`;
          }
          return y;
        },
      },
      x: {
        formatter: (x) => {
          return chartLabels[x - 1];
        },
      },
    },
  });
 const allZero = chartLabels.length === 0;
  return (
    <Card {...other} sx={{height:'460px'}}>
      <CardHeader title={title} subheader={subheader} sx={{ color: 'black' }} />

{!allZero ? 
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="line" series={chartData} options={chartOptions} height={364} />
      </Box>
      :
      <Stack alignItems="center" justifyContent="center" sx={{height:"calc(100% - 70px)"}}>
        <Typography varient="h5" sx={{fontWeight:700, color:"#212B36"}}>
No data found
        </Typography>
      </Stack>
      }
    </Card>
  );
}
